'use strict';

var React = require('react');

var SvgDataVisualizationMajor = function SvgDataVisualizationMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 2a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2h-1v11.5a1.5 1.5 0 0 1-1.5 1.5h-3.22l.69 2.758a1 1 0 1 1-1.94.485l-.81-3.243h-2.44l-.81 3.242a1 1 0 1 1-1.94-.485l.69-2.757h-3.22a1.5 1.5 0 0 1-1.5-1.5v-11.5h-1a1 1 0 0 1-1-1zm15 3h-2v8h2v-8zm-6 2h2v6h-2v-6zm-2 2h-2v4h2v-4z"
  }));
};

exports.SvgDataVisualizationMajor = SvgDataVisualizationMajor;
